import { NavigationGuardNext, Route } from 'vue-router';
import { NamedLocation } from '../types';
import { isTrainingsModuleEnabled } from '@/ui/auth/auth';

export function guardTrainingsModuleAddon(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (!isTrainingsModuleEnabled.value) {
    const redirectTo: NamedLocation = { name: 'home' };
    next(redirectTo);

    return;
  }

  next();
}
